module.exports = __webpack_public_path__ + "img/login_selected.11ceb4c3.svg";